import { Component } from '@angular/core';

@Component({
  selector: 'dgx-ui-wl-sky-header',
  templateUrl: './sky-header.component.html',
  styleUrls: ['./sky-header.component.scss'],
})
export class SkyHeaderComponent {}
